import { useState } from 'react';

export type PresetKey = '7d' | '30d' | 'quarter' | 'year' | 'custom';

export const PRESETS: { key: PresetKey; label: string; days?: number }[] = [
  { key: '7d', label: '7д', days: 7 },
  { key: '30d', label: '30д', days: 30 },
  { key: 'quarter', label: 'Квартал', days: 90 },
  { key: 'year', label: 'Рік', days: 365 },
  { key: 'custom', label: 'Інший' },
];

export function toIsoDate(date: Date): string {
  return date.toISOString().slice(0, 10);
}

export function useReportDateRange() {
  const [preset, setPreset] = useState<PresetKey>('30d');
  const [from, setFrom] = useState(() => toIsoDate(new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)));
  const [to, setTo] = useState(() => toIsoDate(new Date()));

  const handlePresetChange = (_: unknown, value: PresetKey | null) => {
    if (!value) return;
    setPreset(value);
    const found = PRESETS.find(p => p.key === value);
    if (found?.days) {
      setFrom(toIsoDate(new Date(Date.now() - found.days * 24 * 60 * 60 * 1000)));
      setTo(toIsoDate(new Date()));
    }
  };

  return {
    data: {
      preset,
      from,
      to,
    },
    actions: {
      setFrom,
      setTo,
      handlePresetChange,
    },
  };
}
